<script>
import sendByAddressComponent from '../send_by_address/send_by_address.vue';
import sendByLabelComponent from '../send_by_label/send_by_label.vue';

export default {
  data() {
    return {
      tabs: ['Send by label', 'Send by address'],
      currentTab: 'Send by label',
    };
  },
  components: {
    'send-by-label': sendByLabelComponent,
    'send-by-address': sendByAddressComponent,
  },
  watch: {
    selectedProducts: {
      handler(products) {
        if (products.length === 0) this.$store.dispatch('isset_selected_fbm', null);
      },
      deep: true,
    },
  },
  computed: {
    selectedProducts() {
      return this.$store.getters.getSelectedProducts;
    },
    currentTabComponent() {
      return this.currentTab.split(' ').join('-').toLowerCase();
    },
  },
  methods: {
    close(event) {
      if (typeof event === 'undefined') {
        this.$store.dispatch('isset_selected_fbm', null);
        return;
      }

      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.dispatch('isset_selected_fbm', null);
      }
    },
  },
};
</script>
<template src="./send_FBM.pug" lang="pug"></template>
